import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EventIcon from '@mui/icons-material/Event';
import AttendeesIcon from '@mui/icons-material/Person2';
import SpeakerIcon from '@mui/icons-material/Person2';
import CompanyIcon from '@mui/icons-material/Apartment';
import FaqIcon from '@mui/icons-material/Help';
import EmailIcon from '@mui/icons-material/Email';
import PagesIcon from '@mui/icons-material/ContentCopy';
import InfoIcon from '@mui/icons-material/Info';
import GCMIcon from '@mui/icons-material/Cloud';
import PrintIcon from '@mui/icons-material/Print';
import MapIcon from '@mui/icons-material/Map';
import NotificationsIcon from '@mui/icons-material/Notifications';

import DashboardPage from '../pages/Authorized/DashboardPage';
import AboutPage from '../pages/Authorized/AboutPage';
import SessionsPage from '../pages/Authorized/Sessions';
import SpeakersPage from '../pages/Authorized/Speakers';
import {People} from "@mui/icons-material";
import VendorPage from "../pages/Authorized/OrganizersPage";

export interface MenuI {
    id: string;
    label: string;
    route: string;
}

export interface DrawerMenuI extends MenuI {
    icon: any;
    component: React.ReactElement;
    index?: boolean;
    children?: DrawerMenuI[];
}

const userMenu: MenuI[] = [
    {
        id: 'user-menu-logout',
        label: 'Logout',
        route: '/logout',
    },
    {
        id: 'user-menu-profile',
        label: 'Profile',
        route: '/profile',
    },
    {
        id: 'drawer-bottom-settings',
        label: 'Settings',
        route: '/settings',
    },
];

const drawerMenuTop: DrawerMenuI[] = [
    {
        id: 'drawer-top-dashboard',
        label: 'Dashboard',
        route: '/',
        icon: <DashboardIcon/>,
        component: <DashboardPage/>,
        index: true,
    },
    {
        id: 'drawer-top-organizers',
        label: 'Organizers',
        route: '/organizers',
        icon: <People/>,
        component: <VendorPage/>,
    },
    {
        id: 'drawer-section-event',
        label: 'Events',
        route: '/events-section',
        icon: <DashboardIcon/>,
        component: <DashboardPage/>,
        index: true,
        children: [
            {
                id: 'drawer-top-events',
                label: 'Sessions',
                route: '/sessions',
                icon: <EventIcon/>,
                component: <SessionsPage/>,
            },
            {
                id: 'drawer-top-attendees',
                label: 'Attendees',
                route: '/attendees',
                icon: <AttendeesIcon/>,
                component: <div></div>,
            },
            {
                id: 'drawer-change-type',
                label: 'Change Type',
                route: '/change-type',
                icon: <AttendeesIcon/>,
                component: <div></div>,
            },
            {
                id: 'drawer-top-speakers',
                label: 'Speakers',
                route: '/speakers',
                icon: <SpeakerIcon/>,
                component: <SpeakersPage/>,
            },
            {
                id: 'drawer-top-companies',
                label: 'Companies',
                route: '/companies',
                icon: <CompanyIcon/>,
                component: <div></div>,
            },
            {
                id: 'drawer-top-venue',
                label: 'Venue & Floor plans',
                route: '/venue',
                icon: <MapIcon/>,
                component: <div></div>,
            },
        ],
    },
    {
        id: 'drawer-section-app',
        label: 'APP',
        route: '/app-section',
        icon: <DashboardIcon/>,
        component: <DashboardPage/>,
        children: [
            {
                id: 'drawer-top-faq',
                label: 'FAQs',
                route: '/faq',
                icon: <FaqIcon/>,
                component: <div></div>,
            },
            {
                id: 'drawer-top-contact-us',
                label: 'Messages',
                route: '/contact-us-messages',
                icon: <EmailIcon/>,
                component: <div></div>,
            },
            {
                id: 'drawer-top-pages',
                label: 'Pages',
                route: '/pages',
                icon: <PagesIcon/>,
                component: <div></div>,
            },
            {
                id: 'broadcast-message',
                label: 'Cloud Messaging',
                route: '/cloud-message',
                icon: <GCMIcon/>,
                component: <div></div>,
            },
            {
                id: 'notifications',
                label: 'Notifications',
                route: '/notifications',
                icon: <NotificationsIcon/>,
                component: <div></div>,
            },
        ],
    },
];

const drawerMenuBottom: DrawerMenuI[] = [
    {
        id: 'drawer-bottom-about',
        label: 'About',
        route: '/about',
        icon: <InfoIcon/>,
        component: <AboutPage/>,
    },
];

export default {
    version: '0.0.1-beta',
    companyName: 'Digify',
    companyUrl: 'https://digifymena.com',
    appName: 'Digify Events',
    userMenu,
    drawerMenuTop,
    drawerMenuBottom,
    // backendPath : 'https://digify-mm.duckdns.org'
    // backendPath : 'http://localhost:8000'
    backendPath: '',
};
